import axios from "axios";
import { mapMutations, mapState } from "vuex";
import { getUserInfo, checkAccountLogin } from "api/api";
import { REQUEST_URL, APP_KEY } from "const";
import { checkToken, checkIamToken } from "api/token";
import { signIn } from "../utils/utils";
import { checkCloudAccountLogin } from "../api/api";

export const checkLoginTypeMixin = {
  data() {
    return {
      showPage: false,
    };
  },
  computed: {
    ...mapState("user", ["userInfo"]),
  },
  methods: {
    ...mapMutations("user", [
      "UPDATE_USER_INFO",
      "UPDATE_ACCESS_TOKEN",
      "UPDATE_ACCESS_TOKEN_TYPE",
    ]),
    triggerTabs() {
      document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "visible") {
          if (localStorage.getItem("loginType") === "iam") {
            checkIamToken().catch(() => {
              window.location.reload();
            });
          } else {
            if (!this.userInfo) return;
            const service = axios.create({
              withCredentials: true,
              headers: {
                appKey: APP_KEY,
              },
            });
            const url =
              process.env.NODE_ENV === "development"
                ? `/api/user/getUserInfo?v=${Math.random()}`
                : `${REQUEST_URL}/user/getUserInfo?v=${Math.random()}`;
            service
              .get(url)
              .then(({ data: res }) => {
                if (res.code !== 0) {
                  window.location.reload();
                }
              })
              .catch(() => {
                window.location.reload();
              });
          }
        }
      });
    },
    init() {
      return new Promise(async (resolve, reject) => {
        const nuser = JSON.parse(localStorage.getItem("nuser"));
        const user =
          localStorage.getItem("userInfo") &&
          JSON.parse(localStorage.getItem("userInfo"));
        if (user && nuser.userId !== user.userId) {
          // 判断其他页面切换过账号
          localStorage.clear();
        }
        try {
          await checkToken();
          resolve();
        } catch (e) {
          return reject();
        }
      });
    },
    async loginTypeCheck() {
      localStorage.removeItem("loginType");
      let accessToken = cloudCookies.accessToken;
      if (accessToken) {
        try {
          // 项目自身域名checkToken
          const { code } = await checkCloudAccountLogin(null, {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          });
          if (code === 0) this.UPDATE_ACCESS_TOKEN_TYPE("cloud");
          if (code !== 0) accessToken = "";
        } catch (e) {
          accessToken = "";
        }
      }
      if (!accessToken) {
        // 无效或者当前域无accessToken，查看是否能够跨域获取readerToken
        accessToken = readerCookies.accessToken;
        if (accessToken) {
          try {
            const { code } = await checkAccountLogin(null, {
              headers: {
                Authorization: `Bearer ${accessToken}`,
              },
            });
            if (code !== 0) {
              accessToken = "";
            } else {
              this.UPDATE_ACCESS_TOKEN_TYPE("reader");
            }
          } catch (e) {
            accessToken = "";
          }
        }
      }
      this.UPDATE_ACCESS_TOKEN(accessToken);
      const service = axios.create({
        withCredentials: true,
        headers: {
          appKey: APP_KEY,
        },
      });
      if (accessToken) {
        localStorage.setItem("loginType", "iam");
        localStorage.removeItem("token");
      }
      const url =
        process.env.NODE_ENV === "development"
          ? `/api/user/getUserInfo?v=${Math.random()}`
          : `${REQUEST_URL}/user/getUserInfo?v=${Math.random()}`;
      service
        .get(
          url,
          accessToken
            ? {
                headers: {
                  Authorization: `Bearer ${accessToken}`,
                },
              }
            : {}
        )
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.UPDATE_USER_INFO(res.data);
            localStorage.setItem("nuser", JSON.stringify(res.data));
            localStorage.setItem("userInfo", JSON.stringify(res.data));
            if (res.data.accountType === "COMPANY") {
              return (window.location.href =
                "https://www.foxitcloud.cn/work/printer");
            }
            if (localStorage.getItem("loginType") !== "iam") {
              this.init()
                .then(() => {
                  this.showPage = true;
                })
                .catch(() => {
                  localStorage.clear();
                  this.showPage = true;
                });
            } else {
              this.showPage = true;
            }
          } else {
            localStorage.clear();
            this.showPage = true;
          }
        })
        .catch(() => {
          localStorage.clear();
          this.showPage = true;
        });
    },
    /**
     * [signIn 登录]
     *
     * @return  {[type]}  [return description]
     */
    signIn() {
      signIn();
    },
    /**
     * [获取用户信息]
     *
     * @return  {[type]}       [return description]
     */
    getUserInfo() {
      return new Promise((resolve, reject) => {
        getUserInfo().then(
          (res) => {
            localStorage.setItem("userInfo", JSON.stringify(res.data));
            if (res.data.accountType === "COMPANY") {
              return (window.location.href =
                "https://www.foxitcloud.cn/work/printer");
            }
            resolve(res);
          },
          () => {
            reject();
          }
        );
      });
    },
  },
};
